import React from "react";
import dayjs from "dayjs";

interface Props {
  employeeInfo: any;
}

const PersonalInfo: React.FC<Props> = ({ employeeInfo }) => {
  return (
    <div>
      <h3 className="text-black font-bold text-lg mb-3">Personal Info</h3>

      <div className="flex flex-col gap-3 max-w-xl">
        <input className="border rounded p-2 text-sm" placeholder="First Name" value={employeeInfo?.first_name || ""} readOnly />
        <input className="border rounded p-2 text-sm" placeholder="Last Name" value={employeeInfo?.last_name || ""} readOnly />
        <input className="border rounded p-2 text-sm" placeholder="Email" value={employeeInfo?.email || ""} readOnly />
        <input className="border rounded p-2 text-sm" placeholder="Phone" value={employeeInfo?.phone || ""} readOnly />
        <input className="border rounded p-2 text-sm" placeholder="Hire Date" value={employeeInfo?.hire_date ? dayjs(employeeInfo.hire_date).format("MMM DD, YYYY") : ""} readOnly />

        <div>
          <button className="bg-blue-600 text-white px-4 py-2 rounded opacity-50" disabled>
            Save Personal Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;